/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import BudgetReportList from 'domain/finance/budget/report/List';
import { READ_BUDGET_REPORT } from 'domain/shared/budget';

const BUDGET_REPORT_PATH = '/budgets-report';

const useBudgetReportRoute = () => {
  return createRoute({ listRoute: BUDGET_REPORT_PATH });
};

const BudgetReportRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useBudgetReportRoute();

  return (
    <ProtectedRouter basePath={BUDGET_REPORT_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_BUDGET_REPORT}>
              <BudgetReportList />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

BudgetReportRouter.getRouterPath = () => `${BUDGET_REPORT_PATH}/*`;

export default BudgetReportRouter;
